import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogBase, RentalEventInfo } from 't4core';


@Component({
  selector: 'CSEventlogDialog',
  templateUrl: 'CSEventlogDialog.html',
  styleUrls: ['./CSEventlogDialog.css'],
})
export class CSEventlogDialog extends DialogBase implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<CSEventlogDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super("CSEventlogDialog");

    this.rentalId = data.RentalId;
  }

  public rentalId: number;
  public eventData: RentalEventInfo[];
  public loading: boolean;
  

  async ngOnInit() {
    this.loading = true;
    this.eventData = await this.Api.get<RentalEventInfo[]>("Rental/GetCSEvents", { rentalId: this.rentalId });
    console.log(this.eventData);
    this.eventData = this.eventData.filter(x => x.Note != "");
    console.log(this.eventData);
    this.loading = false;
  }

}

